import { useTranslation } from "react-i18next";

interface AnalyticsPageLoadErrorProps {
  title: string;
  help?: string;
  onRetry(): void;
}

function AnalyticsPageLoadError({
  title,
  help,
  onRetry,
}: AnalyticsPageLoadErrorProps) {
  const { t } = useTranslation();

  return (
    <div className="mx-auto mt-8 max-w-md px-4 text-center">
      <p className="text-sm text-gray-700">{title}</p>
      {help && <p className="mt-1 text-xs text-gray-500">{help}</p>}
      <button
        type="button"
        className="btn-secondary btn-small mt-3"
        onClick={onRetry}
      >
        {t("Common.TryAgain", "Try again")}
      </button>
    </div>
  );
}

export default AnalyticsPageLoadError;
